
import { Component, Prop, Vue } from "vue-property-decorator";
import { ILbl } from "./ILbl";
import FinderVue from "@/finder/Finder.vue";
import Bus from "@/lib/Bus";
import  ButtonVue from "@/lib/Button.vue";
import { LblSvc } from "./LblSvc";
import ClipUseVue from "@/clip/ClipUse.vue";
import ClipAddVue from "@/clip/ClipAdd.vue";
import ClipUseMultiVue from "@/clip/ClipUseMulti.vue";
import ClipAddMultiVue from "@/clip/ClipAddMulti.vue";
import { TreeSvc } from "@/tree/TreeSvc";
import { ObjEvents } from "@/../server/src/mqtt/ObjEvents";
const bus: Bus = new Bus().getBus();


@Component({ components: { ButtonVue, ClipUseVue, ClipAddVue, ClipUseMultiVue, ClipAddMultiVue    } })

export default class LblShortVue extends Vue {
 
  @Prop(Object) lbl:any;
  key: number = 0;
  hovered_lbl:ILbl|undefined
  popup_key=0;
  popupTop=0
  popupLeft=0
  
  lblSvc=new LblSvc();
  treeSvc=new TreeSvc()

  async technologia_produkcyjna_open(lbl:ILbl) {
    if (!lbl) return;
    if (!lbl._id) return;
    if (!lbl.tree_id) return;
    
    const tree=await this.treeSvc.find_by_id(lbl.tree_id)
    if (!tree?._id) {
      alert("Brak technologii dla tej etykiety")
      return;
    }
    window.router.push({ path: `/technologie/${tree?._id}` }) 
  }


  async refresh() {
      this.key++;
  }

   selected(id:any) {
    if (!this.$route.params.lbl_id) return '';
    if (this.$route.params.lbl_id==id ) return 'selected-row';
    return '';
  }

  async del_label(l: ILbl) {
    if (confirm("Na pewno skasować etykietę?")) {
      l.status = "SKASOWANY";
      const lbl = await this.lblSvc.set_status(l);
      alert("Etykieta została skasowana")
    }
  }

  async status_changed(e:any) {
     
      const obj = e.detail;
      if (obj.type!="lbl") return;
      if (obj._id!=this.lbl._id) return;
      this.lbl.status = obj.status
      this.key++
  }

  async mounted() {
    bus.register(ObjEvents.status_changed, this.status_changed);
    await this.refresh();
  }

  async beforeDestroy() {
    bus.remove(ObjEvents.status_changed, this.status_changed);
  }

  async show_technologia(tree_id:string) {
    window.router.push({ path: "/technologie/"+tree_id}) 
    this.key++
  }

  
  async show_lbl(lbl_id:string, prj_id:string) {
    window.router.push({ path: `/projekty/${prj_id}/etykiety/${lbl_id}` })  
    //window.location.reload(true); 
  }


  obj_to_clipboard(lbl:ILbl) {
    let str=""
    if (!lbl) return "";
    if (!lbl._id) return "";

    str=JSON.stringify(lbl,null,2)
    navigator.clipboard.writeText(str)
    alert("Skopiowano JSON (lbl) clipboardu")
    return str;
  }

  async duplicate_lbl(_id: any) {

    const lbl1 = await this.lblSvc.duplicate(_id);
    if (lbl1 && lbl1._id) {
      alert("Skopiowano")
      console.log(lbl1)
    }
    else {
      alert("Problem w kopiowaniu!")
    }
    await this.refresh();

  }


  async connect_lbl(lbl: any) {
    if (!lbl.connect) (lbl.connect=false)
    lbl.connect = !lbl.connect
    this.key++
  }

  async handleMouseEnterRow(lbl:ILbl, event:MouseEvent) {
      this.hovered_lbl = lbl;
      const lbl1 = await this.lblSvc.find_by_id(lbl._id)
      if (lbl1 && lbl1._id) {
        this.lbl.lbl_refs=lbl1.lbl_refs
        this.lbl.file_path_512=lbl1.file_path_512
        //this.popupTop = event.clientY +30; // Adjust the value to fine-tune the position
        //this.popupLeft = event.clientX +100; // Adjust the value to fine-tune the position
        this.popupTop = event.clientY +30; // Adjust the value to fine-tune the position
        this.popupLeft = event.clientX +100; // Adjust the value to fine-tune the position
        this.popup_key++
        console.log(this.popupTop)
      }
  }

  handleMouseLeaveRow() {
    this.hovered_lbl = undefined;
    this.popup_key++
  }


}


